var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlarmTypeMgt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  var unique = Math.random().toString(36).substring(2);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.762 2.722H2.814A1.893 1.893 0 00.949 4.478l-.005.168v11.291a1.893 1.893 0 001.702 1.911l.166.01h13.962a1.893 1.893 0 001.865-1.755l.005-.168V9.01c0-.542-.267-1.1-.732-1.554l-.145-.133-.053-.114v-1.09c0-1.102-.855-2.18-1.865-2.271l-.139-.007h-5.427l-.132-.078-.164-.303a1.37 1.37 0 00-1.086-.731l-.14-.006zm-.033 1.229l.132.08 1.962 3.703c.097.173.266.29.455.323l.096.01h5.067c.351.001.866.477.937.834l.009.08v6.923a.659.659 0 01-.51.653l-.104.017H2.8A.644.644 0 012.198 16l-.002-.093V4.622a.659.659 0 01.509-.654l.105-.017h5.919zm7 1.144c.327 0 .69.473.744.913l.007.11v.544l-.141.15-.03.001h-4.448l-.133-.08-.856-1.638h4.857z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmTypeMgt);
export default __webpack_public_path__ + "static/assets/alarmTypeMgt.8c03c434.svg";
export { ForwardRef as ReactComponent };